import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Photography from './pages/Photography';
import PortfolioDetail from './pages/PortfolioDetail';
import Visualizations from './pages/Visualizations';

// Styles
import './styles/main.css';

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/about" exact component={About} />
        <Route path="/photography" exact component={Photography} />
        <Route path="/portfolio/:id" exact component={PortfolioDetail} />
        <Route path="/visualizations" exact component={Visualizations} />

        {/* GitHub redirects */}
        <Route path="/github-simpsons" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/SimpsonsGPT';
          return null;
        }} />
        <Route path="/github-economist" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/EconomistGPT';
          return null;
        }} />
        <Route path="/github-keyword" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/t5_keyword_to_text';
          return null;
        }} />
        <Route path="/github-t5-dzongkha" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/T5-for-dzongkha-romanization';
          return null;
        }} />
        <Route path="/github-chileno" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/ChilenoGPT';
          return null;
        }} />
        <Route path="/github-chatgpt" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/longform_edtech_BERT';
          return null;
        }} />
        <Route path="/github-bert-ed" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/BERT_edtech_tools';
          return null;
        }} />
        <Route path="/github-bert-document" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/nlp_social_science/blob/main/document_similarity_with_BERT.ipynb';
          return null;
        }} />
        <Route path="/github-bert-heatmap" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/data_prep_for_visualizations/blob/main/notebooks/BERT_vector_space.ipynb';
          return null;
        }} />
        <Route path="/github-literary" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/NLP_literary_analysis';
          return null;
        }} />
        <Route path="/github-orthographic" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/data_prep_for_visualizations/blob/main/notebooks/character_counts.ipynb';
          return null;
        }} />
        <Route path="/github-social-science" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/nlp_social_science';
          return null;
        }} />
        <Route path="/github-linguistic" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/linguistic_similarity_mapping';
          return null;
        }} />
        <Route path="/github-ritmo" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/deep_ritmo';
          return null;
        }} />
        <Route path="/github-french" component={() => {
          window.location.href = 'https://github.com/s-cafferty-nlp/french_translator_pytorch';
          return null;
        }} />
      </Switch>
    </Router>
  );
};

export default App;
